import script from "./VerificationPaymentModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerificationPaymentModal.vue?vue&type=script&setup=true&lang=ts"

import "./VerificationPaymentModal.vue?vue&type=style&index=0&id=5598b595&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5598b595"]])

export default __exports__